import type { TeamsFilterKey } from '@/common/api/types/itemFilters';
import { TeamSource, type TeamSourceType } from '@/features/teams/types';

// A team only carries a sourceType when it came from a sync; the capacity service leaves the
// column null for teams created in Loop, so null is the "Loop" source rather than a missing value.
// Index positions are encoded into shared filter URLs (see teamSourceFilter.ts) - append new
// sources at the end and never reorder or remove one, or existing links decode to the wrong source.
export const TEAM_SOURCE_FILTER_VALUES = [
  null,
  TeamSource.JIRA_TEAM,
  TeamSource.TEMPO_TEAM,
] as const satisfies readonly (TeamSourceType | null)[];

export type TeamSourceFilterValue = (typeof TEAM_SOURCE_FILTER_VALUES)[number];

// The capacity service models the Loop source as a team with no sourceType, so the null filter
// value travels as an explicit LOOP member of the `sourceTypes` query param's enum.
const API_LOOP_SOURCE = 'LOOP';

export const toTeamSourceApiValues = (sources: readonly TeamSourceFilterValue[]): string[] =>
  sources.map((source) => source ?? API_LOOP_SOURCE);

export const TEAMS_PICKLIST_FILTERS = [
  'roleId',
  'loopId',
  'skillId',
  'sourceType',
] as const satisfies readonly TeamsFilterKey[];

export const getTeamsTableFilters = () => [...TEAMS_PICKLIST_FILTERS] as const;
